if (!customElements.get("shipping-progress-upsell")) {
  customElements.define(
    "shipping-progress-upsell",
    class ShippingProgressUpsell extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", this.onButtonClick.bind(this));
      }

      onButtonClick(event) {
        if (event.target.matches(".upsell-add-btn")) {
          event.preventDefault();
          this.addToCart(event.target);
        }
      }

      async addToCart(button) {
        if (button.disabled) return;

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        const shippingProgress = this.closest("shipping-progress");
        const messages = {
          adding: shippingProgress.dataset.labelAdding || "...",
          added: shippingProgress.dataset.labelAdded || "Added",
          error: shippingProgress.dataset.labelError || "Error",
        };

        const originalText = button.textContent;
        button.textContent = messages.adding;
        button.disabled = true;

        try {
          const response = await fetch(window.routes.cart_add_url, {
            ...fetchConfig(),
            body: JSON.stringify({
              id: parseInt(variantId),
              quantity: 1,
            }),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
              errorData.description || "Failed to add item to cart"
            );
          }

          const responseData = await response.json();

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "shipping-progress-upsell",
            cartData: responseData,
            variantId: variantId,
          });

          button.textContent = messages.added;

          setTimeout(() => {
            this.style.display = "none";
            button.textContent = originalText;
            button.disabled = false;
          }, 900);
        } catch (error) {
          console.error("Error adding upsell to cart:", error);
          button.textContent = messages.error;

          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 1500);
        }
      }
    }
  );
}

if (!customElements.get("shipping-progress")) {
  customElements.define(
    "shipping-progress",
    class ShippingProgress extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}
